// import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import * as FundingActions from './funding.actions';
// import { FundingEntity } from './funding.models';
import { IFundingState } from './funding.models';

// export const FUNDING_FEATURE_KEY = 'funding';

// export interface FundingState extends EntityState<FundingEntity> {
//   selectedId?: string | number; // which Funding record has been selected
//   loaded: boolean; // has the Funding list been loaded
//   error?: string | null; // last known error (if any)
// }

// export interface FundingPartialState {
//   readonly [FUNDING_FEATURE_KEY]: FundingState;
// }

// export const fundingAdapter: EntityAdapter<FundingEntity> =
//   createEntityAdapter<FundingEntity>();

// export const initialFundingState: FundingState = fundingAdapter.getInitialState(
//   {
//     // set initial required properties
//     loaded: false,
//   }
// );

// 26-03-2024
// export const FUNDING_FEATURE_KEY = 'funding';
// export interface FundingPartialState {
//   readonly [FUNDING_FEATURE_KEY]: IFundingState;
// }

// const stateGuard = (state: IFundingState): IFundingState => state;

export const FUNDING_FEATURE_KEY = 'funding';

const initialState: IFundingState = {
  id: 'funding-state',
  name: 'funding',
  isLoaded: false,
  debitCredit: {
    isSuccess: false,
    isProcessing: false,
    cards: [],
    // Other properties of debitCredit if any
  },
  // Other properties of the state if any
};

const stateGuard = (state: IFundingState): IFundingState => state;

// initialFundingState
const reducer = createReducer(
  // on(FundingActions.initFunding, (state) => ({
  //   ...state,
  //   loaded: false,
  //   error: null,
  // })),
  // on(FundingActions.loadFundingSuccess, (state, { funding }) =>
  //   fundingAdapter.setAll(funding, { ...state, loaded: true })
  // ),
  // on(FundingActions.loadFundingFailure, (state, { error }) => ({
  //   ...state,
  //   error,
  // })),
  initialState,
  on(
    FundingActions.clearFundingState,
    () => initialState
  ),
  on(FundingActions.initFundingState, (state) => stateGuard({
    ...state,
    id: 'funding-state',
    name: 'funding',
  })),
  on(FundingActions.loadFundingStateSuccess, (state) => stateGuard({
    ...state as IFundingState,
    isLoaded: true,
  })),
  on(FundingActions.loadFundingStateFailure, (state, { error }) => stateGuard({
    ...state as IFundingState,
    error,
  })),

  /**
   * GET API Request
   */
  on(FundingActions.depositDebitCreditAPI, (state) => stateGuard({
    ...state as IFundingState,
    depositDebitCreditCard: {
      ...(state as IFundingState).depositDebitCreditCard,
      isSuccess: undefined,
      isProcessing: true,
      response: undefined
    },
    error: undefined
  })),

  on(FundingActions.withdrawDebitCreditAPI, (state) => stateGuard({
    ...state as IFundingState,
    withdrawDebitCreditCard: {
      ...(state as IFundingState).withdrawDebitCreditCard,
      isSuccess: undefined,
      isProcessing: true,
      response: undefined
    },
    error: undefined
  })),

  on(FundingActions.getDebitCreditAPI, (state) => stateGuard({
    ...state as IFundingState,
    debitCredit: {
      ...(state as IFundingState).debitCredit,
      isSuccess: undefined,
      isProcessing: true,
      cards: undefined
    },
    error: undefined
  })),

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  on(FundingActions.addDebitCreditAPI, (state, action) => stateGuard({
    ...state as IFundingState,
    debitCredit: {
      ...(state as IFundingState).debitCredit,
      // cards: [...(state?.debitCredit?.cards || []), action.card],
      isProcessing: true
    },
    error: undefined
  })),

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  on(FundingActions.deleteDebitCreditAPI, (state, { orderId }) => stateGuard({
    ...state as IFundingState,
    debitCredit: {
      ...(state as IFundingState).debitCredit,
      // cards: state?.debitCredit?.cards?.filter(card => card.OrderId !== orderId),
      isProcessing: true
    },
    error: undefined
  })),

  // on(FundingActions.deleteDebitCreditAPI, (state) => stateGuard({
  //   ...state as IFundingState,
  //   debitCredit: {
  //     ...(state as IFundingState).debitCredit,
  //     cards: undefined
  // cards: (state.debitCredit.cards || []).filter((card: IDebitCreditCard) =>
  // card.OrderId !== orderId)
  //   },
  //   error: undefined
  // })),

  // on(FundingActions.deleteDebitCreditAPI, (state, { orderId }) => stateGuard({
  //   ...state,
  //   debitCredit: {
  //     ...state.debitCredit,
  //     cards: state?.debitCredit?.cards?.filter(card => card.OrderId !== orderId)
  //   },
  //   error: undefined
  // })),

  on(FundingActions.depositPromoCodeAPI, (state) => stateGuard({
    ...state as IFundingState,
    depositPromoCode: {
      ...(state as IFundingState).depositPromoCode,
      isSuccess: undefined,
      isProcessing: true,
      response: undefined
    },
    error: undefined
  })),

  on(FundingActions.depositMoneyPakAPI, (state) => stateGuard({
    ...state as IFundingState,
    depositMoneyPak: {
      ...(state as IFundingState).depositMoneyPak,
      isSuccess: undefined,
      isProcessing: true,
      response: undefined
    },
    error: undefined
  })),

  on(FundingActions.depositCryptoCurrencyAPI, (state) => stateGuard({
    ...state as IFundingState,
    depositCryptoCurrency: {
      ...(state as IFundingState).depositCryptoCurrency,
      isSuccess: undefined,
      isProcessing: true,
      response: undefined
    },
    error: undefined
  })),

  on(FundingActions.getFundingLimitAPI, (state) => stateGuard({
    ...state as IFundingState,
    fundingLimit: {
      ...(state as IFundingState).fundingLimit,
      isSuccess: undefined,
      isProcessing: true,
      response: undefined,
      list: undefined
    },
    error: undefined
  })),

  on(FundingActions.getPendingAchAPI, (state) => stateGuard({
    ...state as IFundingState,
    pendingAch: {
      ...(state as IFundingState).pendingAch,
      isSuccess: undefined,
      isProcessing: true,
      response: undefined,
      list: undefined
    },
    error: undefined
  })),

  on(FundingActions.depositOnlineCheckAPI, (state) => stateGuard({
    ...state as IFundingState,
    depositOnlineCheckACH: {
      ...(state as IFundingState).depositOnlineCheckACH,
      isSuccess: undefined,
      isProcessing: true,
      response: undefined
    },
    error: undefined
  })),

  on(FundingActions.getAchAccountAPI, (state) => stateGuard({
    ...state as IFundingState,
    ach: {
      ...(state as IFundingState).ach,
      isSuccess: undefined,
      isProcessing: true,
      response: undefined,
      accounts: undefined
    },
    error: undefined
  })),

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  on(FundingActions.addAchAccountAPI, (state, action) => stateGuard({
    ...state as IFundingState,
    ach: {
      ...(state as IFundingState).ach,
      // cards: [...(state?.debitCredit?.cards || []), action.card],
      isSuccess: undefined,
      isProcessing: true,
      response: undefined
    },
    error: undefined
  })),

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  on(FundingActions.deleteAchAccountAPI, (state, { accountId }) => stateGuard({
    ...state as IFundingState,
    ach: {
      ...(state as IFundingState).ach,
      // accounts: state?.ach?.accounts?.filter(account => account.accountId !== accountId),
      isSuccess: undefined,
      isProcessing: true,
      response: undefined
    },
    error: undefined
  })),

  on(FundingActions.withdrawCheckByEmailAPI, (state) => stateGuard({
    ...state as IFundingState,
    withdrawCheckByEmail: {
      ...(state as IFundingState).withdrawCheckByEmail,
      isSuccess: undefined,
      isProcessing: true,
      response: undefined
    },
    error: undefined
  })),

  on(FundingActions.withdrawOnlineCheckAPI, (state) => stateGuard({
    ...state as IFundingState,
    withdrawOnlineCheckACH: {
      ...(state as IFundingState).withdrawOnlineCheckACH,
      isSuccess: undefined,
      isProcessing: true,
      response: undefined
    },
    error: undefined
  })),

  /**
   * GET API Response SUCCESS
   */
  on(FundingActions.depositDebitCreditAPISuccess, (state, { successResponse }) => stateGuard({
    ...state as IFundingState,
    depositDebitCreditCard: {
      ...(state as IFundingState).depositDebitCreditCard,
      isSuccess: true,
      isProcessing: false,
      response: successResponse
    },
  })),

  on(FundingActions.withdrawDebitCreditAPISuccess, (state, { successResponse }) => stateGuard({
    ...state as IFundingState,
    withdrawDebitCreditCard: {
      ...(state as IFundingState).withdrawDebitCreditCard,
      isSuccess: true,
      isProcessing: false,
      response: successResponse
    },
  })),

  on(FundingActions.getDebitCreditAPISuccess, (state, { successResponse }) => stateGuard({
    ...state as IFundingState,
    debitCredit: {
      ...(state as IFundingState).debitCredit,
      cards: successResponse
    },
  })),

  on(FundingActions.addDebitCreditAPISuccess, (state, { newCard, successResponse }) => stateGuard({
    ...state as IFundingState,
    debitCredit: {
      ...(state as IFundingState).debitCredit,
      cards: [...(state?.debitCredit?.cards || []), newCard],
      response: successResponse,
      isSuccess: true,
    },
  })),

  on(FundingActions.deleteDebitCreditAPISuccess, (state, { orderId, successResponse }) => stateGuard({
    ...state as IFundingState,
    debitCredit: {
      ...(state as IFundingState).debitCredit,
      cards: state?.debitCredit?.cards?.filter(card => card.OrderId !== orderId),
      response: successResponse,
      isSuccess: true,
    },
  })),

  on(FundingActions.getTransactionFeeAPISuccess, (state, { successResponse }) => stateGuard({
    ...state as IFundingState,
    depositDebitCreditCard: {
      ...(state as IFundingState).depositDebitCreditCard,
      cardFee: successResponse
    },
  })),

  on(FundingActions.depositPromoCodeAPISuccess, (state, { successResponse }) => stateGuard({
    ...state as IFundingState,
    depositPromoCode: {
      ...(state as IFundingState).depositPromoCode,
      isSuccess: true,
      isProcessing: false,
      response: successResponse
    },
  })),

  on(FundingActions.depositMoneyPakAPISuccess, (state, { successResponse }) => stateGuard({
    ...state as IFundingState,
    depositMoneyPak: {
      ...(state as IFundingState).depositMoneyPak,
      isSuccess: true,
      isProcessing: false,
      response: successResponse
    },
  })),

  on(FundingActions.depositCryptoCurrencyAPISuccess, (state, { successResponse }) => stateGuard({
    ...state as IFundingState,
    depositCryptoCurrency: {
      ...(state as IFundingState).depositCryptoCurrency,
      isSuccess: true,
      isProcessing: false,
      response: successResponse
    },
  })),

  on(FundingActions.getFundingLimitAPISuccess, (state, { successResponse }) => stateGuard({
    ...state as IFundingState,
    fundingLimit: {
      ...(state as IFundingState).fundingLimit,
      isSuccess: true,
      isProcessing: false,
      response: successResponse,
      list: successResponse
    },
  })),

  on(FundingActions.getPendingAchAPISuccess, (state, { successResponse }) => stateGuard({
    ...state as IFundingState,
    pendingAch: {
      ...(state as IFundingState).pendingAch,
      isSuccess: true,
      isProcessing: false,
      response: successResponse,
      list: successResponse
    },
  })),

  on(FundingActions.addPendingAch, (state, { pendingDeposit, successResponse }) => stateGuard({
    ...state as IFundingState,
    pendingAch: {
      ...(state as IFundingState).pendingAch,
      isSuccess: true,
      isProcessing: false,
      response: successResponse,
      list: [...(state?.pendingAch?.list || []), pendingDeposit]
    },
  })),

  on(FundingActions.depositOnlineCheckAPISuccess, (state, { successResponse }) => stateGuard({
    ...state as IFundingState,
    depositOnlineCheckACH: {
      ...(state as IFundingState).depositOnlineCheckACH,
      isSuccess: true,
      isProcessing: false,
      response: successResponse
    },
  })),

  on(FundingActions.getAchAccountAPISuccess, (state, { successResponse }) => stateGuard({
    ...state as IFundingState,
    ach: {
      ...(state as IFundingState).ach,
      isSuccess: true,
      isProcessing: false,
      response: successResponse,
      accounts: successResponse
    },
  })),

  on(FundingActions.addAchAccountAPISuccess, (state, { newAccount, successResponse }) => stateGuard({
    ...state as IFundingState,
    ach: {
      ...(state as IFundingState).ach,
      isSuccess: true,
      isProcessing: false,
      response: successResponse,
      accounts: [...(state?.ach?.accounts || []), newAccount]
    },
  })),

  on(FundingActions.deleteAchAccountAPISuccess, (state, { accountId, successResponse }) => stateGuard({
    ...state as IFundingState,
    ach: {
      ...(state as IFundingState).ach,
      isSuccess: true,
      isProcessing: false,
      response: successResponse,
      accounts: state?.ach?.accounts?.filter(account => account?.AccountId !== Number(accountId))
    },
  })),

  on(FundingActions.withdrawCheckByEmailAPISuccess, (state, { successResponse }) => stateGuard({
    ...state as IFundingState,
    withdrawCheckByEmail: {
      ...(state as IFundingState).withdrawCheckByEmail,
      isSuccess: true,
      isProcessing: false,
      response: successResponse
    },
  })),

  on(FundingActions.withdrawOnlineCheckAPISuccess, (state, { successResponse }) => stateGuard({
    ...state as IFundingState,
    withdrawOnlineCheckACH: {
      ...(state as IFundingState).withdrawOnlineCheckACH,
      isSuccess: true,
      isProcessing: false,
      response: successResponse
    },
  })),

  /**
   * GET API Response ERROR
   */
  // depositDebitCreditCard
  on(FundingActions.depositDebitCreditAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    depositDebitCreditCard : {
      ...(state as IFundingState).depositDebitCreditCard,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse
    },
    error: errorResponse
  })),

  on(FundingActions.withdrawDebitCreditAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    withdrawDebitCreditCard : {
      ...(state as IFundingState).withdrawDebitCreditCard,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse
    },
    error: errorResponse
  })),

  on(FundingActions.getDebitCreditAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    debitCredit : {
      ...(state as IFundingState).debitCredit,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse
    },
    error: errorResponse
  })),

  on(FundingActions.addDebitCreditAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    debitCredit : {
      ...(state as IFundingState).debitCredit,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse
    },
    error: errorResponse
  })),

  on(FundingActions.deleteDebitCreditAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    debitCredit : {
      ...(state as IFundingState).debitCredit,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse
    },
    error: errorResponse
  })),

  on(FundingActions.depositPromoCodeAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    depositPromoCode : {
      ...(state as IFundingState).depositPromoCode,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse
    },
    error: errorResponse
  })),

  on(FundingActions.depositMoneyPakAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    depositMoneyPak : {
      ...(state as IFundingState).depositMoneyPak,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse
    },
    error: errorResponse
  })),

  on(FundingActions.depositCryptoCurrencyAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    depositCryptoCurrency : {
      ...(state as IFundingState).depositCryptoCurrency,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse
    },
    error: errorResponse
  })),

  on(FundingActions.getFundingLimitAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    fundingLimit : {
      ...(state as IFundingState).fundingLimit,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse,
      list: undefined
    },
    error: errorResponse
  })),

  on(FundingActions.getPendingAchAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    pendingAch : {
      ...(state as IFundingState).pendingAch,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse,
      list: undefined
    },
    error: errorResponse
  })),

  on(FundingActions.depositOnlineCheckAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    depositOnlineCheckACH : {
      ...(state as IFundingState).depositOnlineCheckACH,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse
    },
    error: errorResponse
  })),

  on(FundingActions.getAchAccountAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    ach : {
      ...(state as IFundingState).ach,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse
    },
    error: errorResponse
  })),

  on(FundingActions.addAchAccountAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    ach : {
      ...(state as IFundingState).ach,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse
    },
    error: errorResponse
  })),

  on(FundingActions.deleteAchAccountAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    ach : {
      ...(state as IFundingState).ach,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse
    },
    error: errorResponse
  })),

  on(FundingActions.withdrawCheckByEmailAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    withdrawCheckByEmail : {
      ...(state as IFundingState).withdrawCheckByEmail,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse
    },
    error: errorResponse
  })),

  on(FundingActions.withdrawOnlineCheckAPIFailed, (state, { errorResponse }) => stateGuard({
    ...state as IFundingState,
    withdrawOnlineCheckACH : {
      ...(state as IFundingState).withdrawOnlineCheckACH,
      isSuccess: false,
      isProcessing: false,
      response: errorResponse
    },
    error: errorResponse
  })),

  on(FundingActions.setError, (state, { error }) => stateGuard({
    ...state as IFundingState,
    error
  }))
);

export function fundingReducer(
  state: IFundingState | undefined,
  action: Action
) {
  return reducer(state, action);
}
